import useCacheFactory from '@nicolaudie-group/ng-ui-kit/composables/useCacheFactory'
import useAction from '@/composables/useAction'

const useCache = useCacheFactory(useAction)

export default useCache
